<style>

.circle{
  width: 40px;
  height: 40px;
  border-radius: 40px;
}
.you{
  /* box-shadow: -4px 0 10px #9285bd; */
  box-shadow: -4px 0 7px rgba(0,0,0,0.3);
}
.me{
  /* box-shadow: 4px 0 10px #7fb980; */
  box-shadow: 4px 0 7px rgba(0,0,0,0.3);
}

.friend{
  display: grid;
  grid-template-columns: 33px auto;
}

.new-message{
  position: fixed;
  bottom: 10px;
  left: 10px;
  right: 10px;
  height: 45px;
  display: grid;
  grid-template-columns: auto 50px;
  border: 2px #cbcbcb solid;
  border-radius: 40px;
  background-color: black;
}
.message-text{
  grid-column: 1;
  padding: 5px 0 0 10px;
}
.send{
  grid-column: 2;
  padding: 6px 0 0 0;
  text-align: center;
}
.has-new-message{
  height: 60px;
}

input[type="text"]{
  background-color: black;
  border-radius: 0;
  color: #cbcbcb;
  border: none;
  height: 35px;
  outline: none;
}

.icon-send{
  font-size: 33px;
  color: #cbcbcb;
}

.from-me{
  display: grid;
  grid-template-columns: auto 50px;
  margin-left: 35px;
  color: black;
  margin-bottom: 20px;
  /* background: linear-gradient(to right, #fff0, #ffe9f9 75px, #ffe9f9 100%); */
  background: linear-gradient(to left, #fff, #a7f5aa 100px, #a7f5aa 100%);
  border-radius: 5px;
  
}
.from-me-text{
  grid-column: 1;
  margin-right: 5px;
  padding: 10px;
}
.from-me-pic{
  grid-column: 2;
  padding: 8px 0 0 0;
}

.from-you{
  display: grid;
  grid-template-columns: 50px auto;
  margin-right: 35px;
  color: black;
  margin-bottom: 20px;
  background: linear-gradient(to right, #fff, #9285bd 100px, #9285bd 100%);
  border-radius: 5px;
}
.from-you-pic{
  grid-column: 1;
  text-align: right;
  padding: 8px 0 0 0;
}
.from-you-text{
  grid-column: 2;
  margin-left: 5px;
  padding: 10px;
}
.received{
  font-size: 14px;
  margin: 10px 0 0 0;
}

</style>

<Header 
back="{true}"
on:addEvent="{ () => push('/edit-event/new') }"
on:back="{ () => { pop() } }">Rose Alibaster</Header>
<div class="has-header"></div>


{#each items as item}
  
  {#if item.from == 'me'}
  
  <div class="from-me">
    <div class="from-me-text">
      <div>{item.text}</div>
      <div class="received"> <DateAgo timestamp="{item.received}" currentTime="{currentTime}"></DateAgo> </div>
    </div>
    <div class="from-me-pic"> <img src="/i/alison-james.jpg" alt="" class="circle me"> </div>
  </div>
  
  {/if}

  {#if item.from != 'me'}
  <div class="from-you">
    <div class="from-you-pic"> <img src="/i/rose-alibaster.jpg" alt="" class="circle you"> </div>
    <div class="from-you-text">  
      <div>{item.text}</div>
      <div class="received"> <DateAgo timestamp="{item.received}" currentTime="{currentTime}"></DateAgo> </div>
    </div>
  </div>
  {/if}

{/each}

<div class="has-new-message"></div>

<div class="new-message">
  <div class="message-text"> <input type="text" id="newMessage" bind:value="{newMessage}" placeholder="Message" on:keyup="{checkEnter}" on:focus="{scroll}" autocomplete="off"> </div>
  <div class="send" on:click="{send}"> <i class="icon-send"></i> </div>
</div>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Header from "../components/Header.svelte";
import DateAgo from "../components/DateAgo.svelte";

let newMessage = "";

let items = [
  {from: "0006", received: Date.now() - 86400000 - 86400000, text: "Hey girl!  You wanna go smell roses with me?"},
  {from: "me", received: Date.now() - 86400000, text: "Nah girl, I can't.  I have work..."},
  {from: "0006", received: Date.now(), text: "It's cool!  I'll ask Jimmy to go!"},
];

let possibleResponses = [
  "Oh my gosh!",
  "What girl?!  That's crazy!",
  "Wow!",
  "Niiice!",
  "Yo, girl, OMG",
];

// update the event times every X minutes
let interval = setInterval( () => { currentTime =  Date.now() }, 1000 * 60 * 1);
let currentTime = Date.now();


// import { onMount } from "svelte";
// onMount(async () => {
//   setInterval( () => {window.scrollTo(0,document.body.scrollHeight);}, 1000);
// });


function checkEnter(e) {
  if (e.key == "Enter") {
    send();
  }
}

function send() {
  if (newMessage == "") return;
  
  items.push({from: "me", received: Date.now(), text: newMessage});
  items = items;
  
  newMessage = "";
  
  document.getElementById("newMessage").focus();
  
  setTimeout(() => {
    window.scrollTo(0,document.body.scrollHeight);
  }, 1);
  
  setTimeout(() => {
    let t = Math.round(Math.random() * (possibleResponses.length-1) );
    items.push({from: "0006", received: Date.now(), text: possibleResponses[t]});
    items = items;
    setTimeout(() => {
      window.scrollTo(0,document.body.scrollHeight);
    }, 1);
  }, 1500);
  
}


function scroll() {
  setTimeout(() => {
    window.scrollTo(0,document.body.scrollHeight);
  }, 500);
}
</script>